module.exports = __webpack_public_path__ + "media/images/Moins disabled-89a62290c87475e1edd36ae6cf45122b.svg";